// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_2a26wX-mk5","autoplay":"_2OYoi2E2Pg","autoplaySwitch":"y-McGn9OLz","switch":"_1E2IeKewIi","active":"_2_LOhMoW6S"};